<template>
    <section class="article">
        <p>
            {{trans('b1')}}

            <a href="mailto:info@batnorton.com" class="article__link">info@batnorton.com</a>,
            {{trans('b2')}} .
        </p>
    </section>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
